(function ($) {
  if (!$) return;

  $(function () {
    if (typeof $.fn.slick !== 'function') return;

    function shouldUseCarousel() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function bindCarousel(target) {
      var $carousel = target && target.jquery ? target : $(target);
      if (!$carousel.length) return;

      var carouselId = $carousel.attr('id') || 'VerychiCarousel';
      var namespace = '.verychiCarousel' + carouselId;

      function toggleCarousel() {
        var slideCount = $carousel.children('.related-product-card').length;
        var isDesktop = shouldUseCarousel();

        if (isDesktop && slideCount > 0) {
          if (!$carousel.hasClass('slick-initialized')) {
            $carousel.slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: slideCount > 3,
              arrows: slideCount > 3,
              dots: false,
              adaptiveHeight: false,
              speed: 400,
              swipeToSlide: true,
              touchThreshold: 12,
              prevArrow: '<button type="button" class="related-products-carousel__arrow related-products-carousel__arrow--prev" aria-label="Предишни продукти"><span aria-hidden="true">&#8592;</span></button>',
              nextArrow: '<button type="button" class="related-products-carousel__arrow related-products-carousel__arrow--next" aria-label="Следващи продукти"><span aria-hidden="true">&#8594;</span></button>'
            });
          }
        } else if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
      }

      if (!$carousel.data('verychiCarouselBound')) {
        var resizeTimer = null;
        $(window).off('resize' + namespace + ' orientationchange' + namespace).on('resize' + namespace + ' orientationchange' + namespace, function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(toggleCarousel, 120);
        });
        $carousel.data('verychiCarouselBound', true);
      }

      toggleCarousel();
    }

    window.initVerychiDesktopProductCarousel = bindCarousel;

    function parseExcludedCollections(value) {
      if (!value) return [];
      return String(value)
        .toLowerCase()
        .split(/[\s,]+/)
        .map(function (handle) { return handle.trim(); })
        .filter(Boolean);
    }

    function productIsInExcludedCollection(currentCollections, excludedCollections) {
      if (!currentCollections.length || !excludedCollections.length) return false;
      return excludedCollections.some(function (handle) {
        return currentCollections.indexOf(handle) !== -1;
      });
    }

    function filterExcludedRecommendations(recommendations, excludedCollections) {
      if (!excludedCollections.length) return true;

      var cards = recommendations.querySelectorAll('.related-product-card');
      Array.prototype.forEach.call(cards, function (card) {
        var productCollections = (card.getAttribute('data-product-collections') || '')
          .toLowerCase()
          .split(/\s+/)
          .filter(Boolean);

        var shouldRemove = excludedCollections.some(function (handle) {
          return productCollections.indexOf(handle) !== -1;
        });

        if (shouldRemove && card.parentNode) {
          card.parentNode.removeChild(card);
        }
      });

      return recommendations.querySelectorAll('.related-product-card').length > 0;
    }

    function loadShopifyRecommendations() {
      var $mount = $('#ShopifyRelatedProductsMount');
      if (!$mount.length) return;

      var productId = $mount.data('product-id');
      var sectionId = $mount.data('section-id') || 'product-recommendations';
      var limit = parseInt($mount.data('limit'), 10) || 10;
      var intent = $mount.data('intent') || 'related';
      var excludedCollections = parseExcludedCollections($mount.attr('data-excluded-collections'));
      var currentCollections = parseExcludedCollections($mount.attr('data-current-collections'));
      var shouldFilterExcluded = !productIsInExcludedCollection(currentCollections, excludedCollections);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      var url = root + 'recommendations/products?product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit) + '&section_id=' + encodeURIComponent(sectionId) + '&intent=' + encodeURIComponent(intent);

      fetch(url)
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (text) {
          if (!text) {
            $mount.remove();
            return;
          }

          var html = document.createElement('div');
          html.innerHTML = text;
          var recommendations = html.querySelector('[data-shopify-product-recommendations]');

          if (!recommendations || !recommendations.innerHTML.trim().length) {
            $mount.remove();
            return;
          }

          if (!shouldFilterExcluded || filterExcludedRecommendations(recommendations, excludedCollections)) {
            $mount.html(recommendations.innerHTML).show();
            bindCarousel('#RelatedProductsCarousel');
          } else {
            $mount.remove();
          }
        })
        .catch(function () {
          $mount.remove();
        });
    }

    var recommendationsLoaded = false;

    function scheduleShopifyRecommendations() {
      if (recommendationsLoaded) return;

      var mount = document.getElementById('ShopifyRelatedProductsMount');
      var sentinel = document.getElementById('ProductRecommendationsSentinel') || mount;
      if (!mount) return;

      function run() {
        if (recommendationsLoaded) return;
        recommendationsLoaded = true;
        loadShopifyRecommendations();
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) {
            observer.disconnect();
            run();
          }
        }, { rootMargin: '700px 0px' });
        observer.observe(sentinel);
        return;
      }

      if (window.requestIdleCallback) {
        requestIdleCallback(run, { timeout: 4000 });
      } else {
        window.addEventListener('load', function () {
          setTimeout(run, 1500);
        }, { once: true });
      }
    }

    scheduleShopifyRecommendations();

    $(document).on('shopify:section:load shopify:section:reorder', function () {
      recommendationsLoaded = false;
      loadShopifyRecommendations();
    });
  });

  $(function () {
    var STORAGE_KEY = 'verychi_recently_viewed_products_v1';
    var MAX_RECENTLY_VIEWED = 20;
    var MAX_RENDERED_CARDS = 10;
    var currentHandle = $('#RecentlyViewedProducts').data('current-handle') || '';
    var $header = $('#RecentlyViewedHeader');
    var $section = $('#RecentlyViewedSection');
    var $container = $('#RecentlyViewedProducts');

    if (!currentHandle || !$container.length) return;

    function readRecentlyViewed() {
      try {
        var raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
        if (!Array.isArray(raw)) return [];
        return raw.filter(function (handle) {
          return typeof handle === 'string' && handle.trim() !== '';
        });
      } catch (e) {
        return [];
      }
    }

    function writeRecentlyViewed(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_RECENTLY_VIEWED)));
      } catch (e) {}
    }

    function recordCurrentProduct() {
      var items = readRecentlyViewed().filter(function (handle) {
        return handle !== currentHandle;
      });
      items.unshift(currentHandle);
      writeRecentlyViewed(items);
    }

    function renderRecentlyViewed() {
      var handles = readRecentlyViewed().filter(function (handle) {
        return handle !== currentHandle;
      }).slice(0, MAX_RENDERED_CARDS);

      if (!handles.length) return;

      var renderedHtml = new Array(handles.length);

      function finish() {
        var html = renderedHtml.filter(function (item) { return !!item; }).join('');
        if (!$.trim(html)) return;
        $container.html(html);
        $header.show();
        $section.show();
        if (window.initVerychiDesktopProductCarousel) {
          window.initVerychiDesktopProductCarousel($container);
        }
      }

      var requests = handles.map(function (handle, index) {
        return $.ajax({
          url: '/products/' + encodeURIComponent(handle) + '?view=recently-viewed-card',
          method: 'GET',
          cache: true
        }).done(function (html) {
          html = $.trim(html || '');
          if (html) renderedHtml[index] = html;
        });
      });

      $.when.apply($, requests).always(finish);
    }

    function scheduleRecentlyViewed() {
      var target = document.getElementById('ProductRecommendationsSentinel') || $section[0] || $container[0];
      if (!target) return;

      var rendered = false;
      function run() {
        if (rendered) return;
        rendered = true;
        renderRecentlyViewed();
      }

      if (window.requestIdleCallback) {
        requestIdleCallback(run, { timeout: 1500 });
      } else {
        window.setTimeout(run, 1200);
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) {
            observer.disconnect();
            run();
          }
        }, { rootMargin: '700px 0px' });
        observer.observe(target);
      }
    }

    recordCurrentProduct();
    scheduleRecentlyViewed();
  });
})(window.jQuery);
